import { createSelector } from "reselect";
import { buildAssetId } from 'utils/Assets';
import { ASSET_TYPES } from 'utils/constants';

function getAssets(state){
	return state.assets.items;
}

function getSelected(state){
	return state.selected.assets;
}

function compileAssets(assets, selected){
	if(selected.length === 0 || assets.length === 0){ return assets; }
	return assets.map((v) => {
		const assetId = buildAssetId(v);
		let isSelected = false;

		if(selected.indexOf(assetId) > -1){
			isSelected = true;
		}

		return {
			...v,
			isSelected,
		};
	});
}

function compileSelectedAssets(assets, selected) {
	if (selected.length === 0 || assets.length === 0) {
		return [];
	}
	return assets.reduce((prev, next)=> {
		const assetId = buildAssetId(next);

		if (selected.indexOf(assetId) > -1) {
			prev.push(next);
		}

		return prev;
	}, []);
}

function compileSelectedAssetsToDownload(assets, selected) {
	let richloadAssets = new Set()
		, videoAssets = new Set()
		, imageAssets = new Set()
		, audioAssets = new Set()
		, richloadFileName
		, imageFileName
		, videoFileName
		, audioFileName
		, hasEligibleAssets =  false;
	selected.forEach((asset) => {
		let [assetId, assetType] = asset.split('--');
		let assetData = assets.find(asset => asset.id === parseInt(assetId));

		if(assetType === ASSET_TYPES.RICHLOAD) {
			richloadAssets.add(assetId);
			if(richloadAssets.size === 1) {
				richloadFileName = assetData.name;
			}
		}
		if(assetType === ASSET_TYPES.VIDEO) {
			if(!assetData.encoded) {
				videoAssets.add(assetId);

				if(videoAssets.size === 1) {
					videoFileName = assetData.name;
				}
			}
		}
		if(assetType === ASSET_TYPES.IMAGE) {
			imageAssets.add(assetId);
			if(imageAssets.size === 1) {
				imageFileName = assetData.name;
			}
		}
		if(assetType === ASSET_TYPES.AUDIO) {
			audioAssets.add(assetId);
			if(audioAssets.size === 1) {
				audioFileName = assetData.name;
			}
		}
	});

	if(videoAssets.size > 0 || imageAssets.size > 0 || richloadAssets.size > 0 || audioAssets.size > 0) {
		hasEligibleAssets = true;
	}

	return {
		initialFileNames: {
			richloadFileName,
			imageFileName,
			videoFileName,
			audioFileName,
		},
		assetSets: {
			richloadAssets,
			imageAssets,
			videoAssets,
			audioAssets,
		},
		hasEligibleAssets,
	};
}

function compileSelectedAssetsToTranscode(selected){
	return selected.filter(asset => (asset.assetType === ASSET_TYPES.VIDEO) && (asset.encoded === false));
}

export const buildSelectedAssetList = createSelector([getAssets, getSelected], compileAssets);
export const buildSelectedAssets = createSelector([getAssets, getSelected], compileSelectedAssets);
export const buildSelectedAssetsToDownload = createSelector([getAssets, getSelected], compileSelectedAssetsToDownload);
export const buildSelectedAssetsToTranscode = createSelector([buildSelectedAssets], compileSelectedAssetsToTranscode);

export const PRIVATE = {
	getSelected,
	getAssets,
	compileAssets,
};
